import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(
    Item({
        dates: ['deleted_at', 'created_at', 'updated_at'],
    }),
    {
        state() {
            return {
                id: null,
                course_id: null,
                user_id: null,
                deleted_at: null,
                deleted_by: null,
                created_at: null,
                created_by: null,
                updated_at: null,
                updated_by: null,
                user: null,
                roles: null,
                statuses: null,

                order: null,
            };
        },

        getters: {
            /**
             * Provide the payload to get from.
             * @param state
             * @param getters
             * @returns {function(*): boolean}
             */
            getWithPayload(state, getters) {
                return (getter, payload = {}) => getters[getter](payload);
            },

            id: state => {
                return state.id;
            },
        },

        actions: {},

        mutations: {
            SET: (state, { field, value }) => {
                state[field] = value;
            },
        },
    }
);
